import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import useInjectSEOSettings from './hooks/useInjectSEOSettings';

function SEOInjector() {
  useInjectSEOSettings();
  return null;
}

createRoot(document.getElementById("root")!).render(
  <>
    <SEOInjector />
    <App />
  </>
);
